import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";

/*
  Every section of the Wealth Report reads the same translation block, so the
  lookup lives here rather than being written out eight times.

  `FALLBACK` is only what a section needs before the language file has loaded;
  the real strings are in User.AssetDashboard.AssetDashboard.
*/
export const useReportContent = (fallback) => {
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [content, setContent] = useState(
    websiteCurrentLang?.content?.User?.AssetDashboard?.AssetDashboard || fallback
  );
  useEffect(() => {
    setContent(
      websiteCurrentLang?.content?.User?.AssetDashboard?.AssetDashboard ||
        fallback
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [websiteCurrentLang]);
  return (key) => (content && content[key]) || fallback[key] || key;
};
